// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/Link.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/Link.tsx");
  import.meta.hot.lastModified = "1779484951269.005";
}
// REMIX HMR END

import { Link as RemixLink } from "@remix-run/react";
import clsx from "clsx";
/**
 * Renders a RemixLink using one of the predefined themes.
 * If no theme is selected it will render the `light` theme by default.
 * 
 * @param to The link to visit.
 * @param className Tailwind classes in case you need to add some custom styling.
 * @param theme The theme to apply to the link. `light | dark`
 * @param underline Add this if you want to see underline on hover.
 * @returns A styled RemixLink.
 * 
 * @remarks This component is a wrapper, you can add any non-interactive element as children.
 */

export default function Link({
  to,
  className,
  theme = "light",
  underline = false,
  ...props
}) {
  const themeSelector = {
    dark: "text-secondary-100 hover:text-secondary-200",
    light: "text-secondary-900 hover:text-secondary-500",
    lighter: "text-secondary-900 hover:text-secondary-500"
  };
  const hoverStyles = "hover:underline decoration-secondary-200 decoration-2 underline-offset-8 ";
  const hoverSelector = {
    dark: hoverStyles + "decoration-secondary-200",
    light: hoverStyles + "decoration-secondary-500",
    lighter: hoverStyles + "decoration-secondary-500"
  };
  return <RemixLink className={clsx("transition-colors ease-in-out", themeSelector[theme], className, underline && hoverSelector[theme])} to={to} {...props} />;
}
_c = Link;
;
var _c;
$RefreshReg$(_c, "Link");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;